import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface OnboardingState {
  hasCompletedOnboarding: boolean
  username: string | null

  // Actions
  completeOnboarding: () => void
  setUsername: (name: string) => void
  resetOnboarding: () => void
}

export const useOnboardingStore = create<OnboardingState>()(
  persist(
    (set) => ({
      hasCompletedOnboarding: false,
      username: null,

      completeOnboarding: () => set({ hasCompletedOnboarding: true }),

      setUsername: (name) => set({ username: name }),

      resetOnboarding: () => set({
        hasCompletedOnboarding: false,
        username: null
      }),
    }),
    {
      name: 'waifudo-onboarding',
    }
  )
)
